var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideframe1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 24,
    viewBox: "0 0 312 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.71 6.93999L91.45 4.76999H104.08L102.19 6.93999H93.71Z",
    fill: "#01A1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.31 9.06H49.48V10.89H51.31V9.06Z",
    fill: "#01A1FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.76 4.29999H35.81V8.24999H39.76V4.29999Z",
    fill: "#50DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.88 10.6L94.91 8.57999H101L103.03 10.6H92.88Z",
    fill: "#50DBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 5.42999L70.74 11.93H72.01L78.37 5.42999H77.1Z",
    fill: "#50DBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.24 5.42999L73.88 11.93H75.15L81.51 5.42999H80.24Z",
    fill: "#50DBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.35 5.42999L76.99 11.93H78.26C80.38 9.75999 82.5 7.59999 84.62 5.42999H83.35Z",
    fill: "#50DBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 5.42999L80.14 11.93H81.41C83.53 9.75999 85.65 7.59999 87.77 5.42999H86.5Z",
    fill: "#50DBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.54 5.42999L83.18 11.93H84.45C86.57 9.75999 88.69 7.59999 90.81 5.42999H89.54Z",
    fill: "#50DBFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.88 10.6L101.18 18.89H111.75L108.32 15.47L107.89 17.72H101.53L94.69 10.6H92.88Z",
    fill: "#50DBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.27 4.36L98.05 2.59H105.48L105.16 2.91H98.2L96.75 4.37L96.27 4.36Z",
    fill: "#50DBFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.44 10.5H7.53L5.91 8.88001H1.13V8.48001H6.08L7.69 10.09H20.27L24.29 6.07001H32.76V6.48001H24.46L20.44 10.5Z",
    fill: "#50DBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 7.90999L18.61 6.70999H9.27001L8.10001 7.87999L9.32001 9.07999H18.66L19.83 7.90999ZM18.97 7.90999L17.97 8.90999H10.01L8.97001 7.88999L9.97001 6.88999H17.93L18.97 7.90999Z",
    fill: "#01A1FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.89 5.14001H31.63V7.40001H33.89V5.14001Z",
    fill: "#01A1FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 7.5H0L0 9.76H2.26V7.5Z",
    fill: "#01A1FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M217.87 6.93999L220.14 4.76999H207.51L209.39 6.93999H217.87Z",
    fill: "#01A1FE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M260.28 10.9H262.11V9.06999H260.28V10.9Z",
    fill: "#01A1FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.83 8.25H275.78V4.3H271.83V8.25Z",
    fill: "#01A1FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M218.71 10.6L216.68 8.57999H210.59L208.56 10.6H218.71Z",
    fill: "#50DBFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.49 5.42999L240.85 11.93H239.58C237.46 9.75999 235.34 7.59999 233.22 5.42999H234.49Z",
    fill: "#50DBFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.35 5.42999L237.71 11.93H236.44C234.32 9.75999 232.2 7.59999 230.08 5.42999H231.35Z",
    fill: "#50DBFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.23 5.42999L234.59 11.93H233.32C231.2 9.75999 229.08 7.59999 226.96 5.42999H228.23Z",
    fill: "#50DBFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.09 5.42999L231.45 11.93H230.18C228.06 9.75999 225.94 7.59999 223.82 5.42999H225.09Z",
    fill: "#50DBFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.05 5.42999L228.41 11.93H227.14C225.02 9.75999 222.9 7.59999 220.78 5.42999H222.05Z",
    fill: "#50DBFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M218.71 10.6L210.41 18.89H199.84L203.27 15.47L203.7 17.72H210.06L216.9 10.6H218.71Z",
    fill: "#50DBFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.31 4.36L213.54 2.59H206.11L206.43 2.91H213.38L214.84 4.37L215.31 4.36Z",
    fill: "#50DBFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 0.32H156.09H185.97L187.43 1.78L187.9 1.77L186.13 0L156.09 0L155.5 0L125.46 0L123.69 1.77L124.16 1.78L125.62 0.32H155.5Z",
    fill: "#01A1FE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M274.16 6.75V5.94H248.27L244.31 9.91H242.38L236.84 4.37H207.79L205.35 1.78H106.25L103.81 4.37H74.76L69.22 9.91H67.29L63.32 5.94H37.43V6.75H62.99L66.15 9.91H50.73V10.32H66.56L69.86 13.62H88.2L94.06 7.76H101.87L117.66 23.55H193.95L209.74 7.76H217.55L223.41 13.62H241.75L245.05 10.32H260.88V9.91H245.46L248.62 6.75H274.18H274.16ZM241.41 12.8H223.74L217.88 6.94H209.4L193.61 22.73H118L102.21 6.94H93.73L87.87 12.8H70.2L67.71 10.31H69.4L74.94 4.77H104.09L106.43 2.18H205.19L207.53 4.77H236.68L242.22 10.31H243.91L241.42 12.8H241.41Z",
    fill: "#50DBFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M291.15 10.5H304.06L305.68 8.88001H310.46V8.48001H305.51L303.89 10.09H291.31L287.29 6.07001H278.82V6.48001H287.13L291.15 10.5Z",
    fill: "#50DBFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M291.76 7.90999L292.93 9.07999H302.27L303.49 7.87999L302.32 6.70999H292.98L291.76 7.90999ZM292.62 7.90999L293.66 6.88999H301.62L302.62 7.88999L301.58 8.90999H293.62L292.62 7.90999Z",
    fill: "#01A1FE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M277.7 7.41H279.96V5.15H277.7V7.41Z",
    fill: "#01A1FE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M309.32 9.76999H311.58V7.50999H309.32V9.76999Z",
    fill: "#01A1FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideframe1);
export default __webpack_public_path__ + "static/media/sideframe1.04aad74bf4a95220b9659bfbde17d38c.svg";
export { ForwardRef as ReactComponent };